import { useContext } from 'react';

import {
  FaDiscord,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaRedditSquare,
  FaTwitter
} from 'react-icons/fa';

import AddCompanyLogo from './add-company-logo/add-company-logo.component';
import CompanyLogo from './company-logo/company-logo.component';
import Button from '../reusable/button/button.component';

import {
  ContentContainer,
  MainContainer,
  RowContainer,
  Subtitle,
  Text,
  Title
} from '../../styles/component.styles';

const ICONS = {
  discord: FaDiscord,
  facebook: FaFacebook,
  instagram: FaInstagram,
  linkedIn: FaLinkedin,
  reddit: FaRedditSquare,
  twitter: FaTwitter
};

const SOCIAL_KEYS = ['discord', 'facebook', 'instagram', 'linkedIn', 'reddit', 'twitter'];

const Company = ({ company, getCompany, setShowUpdate }) => {
  const socials = company.socials || {};

  const changeView = () => {
    window.scrollTo(0, 0);
    setShowUpdate(true);
  };

  return (
    <MainContainer>
      <Title>Company Details</Title>

      {!company.logoFilename ? (
        <AddCompanyLogo id={company.id} getCompany={getCompany} />
      ) : (
        <CompanyLogo company={company} getCompany={getCompany} />
      )}

      <ContentContainer>
        <RowContainer flexDirection="column" alignItems="flex-start">
          <RowContainer>
            <Subtitle margin="0 10px 0 0">Name:</Subtitle>
            <Text>{company.name || 'None'}</Text>
          </RowContainer>
          <RowContainer>
            <Subtitle margin="0 10px 0 0">Bio:</Subtitle>
            <Text>{company.bio || 'None'}</Text>
          </RowContainer>
          <RowContainer onClick={() => company.url && window.open(company.url, '_blank')} cursor="pointer">
            <Subtitle margin="0 10px 0 0">URL:</Subtitle>
            <Text>{company.url || 'None'}</Text>
          </RowContainer>
        </RowContainer>

        <RowContainer flexDirection="column" border="1px black solid" margin="20px 0" padding="10px">
          <Title>Social Links</Title>

          {SOCIAL_KEYS.map((key) => {
            const url = socials[key]?.url;
            const Icon = ICONS[key];

            return (
              <div key={key}>
                <Subtitle margin="5px 0">{key.charAt(0).toUpperCase() + key.slice(1)}:</Subtitle>
                <Text margin="5px 0">{url || 'Not set'}</Text>
                {url && Icon && (
                  <RowContainer borderBottom="1px black solid" width="100%">
                    <RowContainer onClick={() => window.open(url, '_blank')} margin="0" cursor="pointer">
                      <Icon />
                    </RowContainer>
                  </RowContainer>
                )}
              </div>
            );
          })}
        </RowContainer>
      </ContentContainer>

      <Button onClick={changeView}>Update</Button>
    </MainContainer>
  );
};

export default Company;